import "./Aside.css";
import AsideBrand from "./AsideBrand";
import { getUser } from "../../../core/Global";
import AsideModulesMenu from "./AsideModulesMenu";
import AsideFooter from "./AsideFooter";

function Aside() {

  const user = getUser()

  return (
    <div id="kt_aside" className="aside overflow-visible pb-5">
      <AsideBrand />
      <AsideModulesMenu />
    </div>

  );
}

export default Aside;
